/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0
THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.
See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};
function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

var HTTPError = (function (_super) {
    __extends(HTTPError, _super);
    function HTTPError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'HTTPError';
        return _this;
    }
    return HTTPError;
}(Error));

var MissingInfoError = (function (_super) {
    __extends(MissingInfoError, _super);
    function MissingInfoError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'MissingInfoError';
        return _this;
    }
    return MissingInfoError;
}(Error));

function getProperty(obj) {
    var props = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        props[_i - 1] = arguments[_i];
    }
    return (obj &&
        props.reduce(function (result, prop) {
            return result === null || result === undefined ? undefined : result[prop];
        }, obj));
}
function getPropertyFromPromisedObject(promise) {
    var props = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        props[_i - 1] = arguments[_i];
    }
    return promise.then(function (obj) { return getProperty.apply(void 0, __spreadArrays([obj], props)); });
}

function catchError(functionName, subclass, defaultValue) {
    if (defaultValue === void 0) { defaultValue = null; }
    return function (reason) {
        if (reason instanceof subclass) {
            console.warn("[" + functionName + "] " + reason.name + ": " + reason.message + ". Using default values instead.");
            return defaultValue;
        }
        throw reason;
    };
}

function handleRequest() {
    return function (request) {
        if (request.ok)
            return request.json();
        throw new HTTPError(request.status + ": " + request.statusText);
    };
}

var apiEndpoint = 'https://admin.publishing.tamedia.ch/admin-api/v1/tenants';
var defaultSiteInformation = {
    key: 'tagesanzeiger',
    abbr: 'ta',
    name: 'Tages-Anzeiger',
    domain: 'tagesanzeiger',
    feedId: 2,
    lang: 'de',
    paywallServiceId: 'tagesanzeiger',
    fbAppId: '147124108642216',
    twitterHandle: '@tagesanzeiger'
};
var catchError$1 = function (subclass) {
    return catchError('getSiteInformation', subclass, defaultSiteInformation);
};
function handleData(domainname) {
    return function (data) {
        var siteInfo = data.find(function (val) { return val.domain === domainname; });
        if (!siteInfo) {
            throw new MissingInfoError("Data for domain \"" + domainname + "\" could not be found");
        }
        return siteInfo;
    };
}
var siteInformationPromise = new Map();
function getSiteInformation(domainname) {
    if (siteInformationPromise.has(domainname)) {
        return siteInformationPromise.get(domainname);
    }
    var promise = fetch(apiEndpoint)
        .then(handleRequest())
        .then(handleData(domainname))
        .catch(catchError$1(HTTPError))
        .catch(catchError$1(MissingInfoError))
        .catch(catchError$1(Error));
    siteInformationPromise.set(domainname, promise);
    return promise;
}
function getLanguage(domainName) {
    return getPropertyFromPromisedObject(getSiteInformation(domainName), 'lang');
}
function getFeedId(domainName) {
    return getPropertyFromPromisedObject(getSiteInformation(domainName), 'feedId');
}
function getNiceName(domainName) {
    return getPropertyFromPromisedObject(getSiteInformation(domainName), 'name');
}
function getFacebookAppId(domainName) {
    return getPropertyFromPromisedObject(getSiteInformation(domainName), 'fbAppId');
}
function getTwitterHandle(domainName) {
    return getPropertyFromPromisedObject(getSiteInformation(domainName), 'twitterHandle');
}

var apiEndpoint$1 = function (tenantId, articleId) {
    return "https://feed-prod.unitycms.io/" + tenantId + "/content/" + articleId;
};
var handleData$1 = function (articleId) { return function (data) {
    if (data === undefined || data === null) {
        throw new MissingInfoError('No data could be downloaded with article ID ' + articleId);
    }
    return data;
}; };
var articleDataPromises = new Map();
function getArticleInformation(tenantId, articleId) {
    if (articleDataPromises.has(articleId)) {
        return articleDataPromises.get(articleId);
    }
    var promise = fetch(apiEndpoint$1(tenantId, articleId))
        .then(handleRequest())
        .then(handleData$1(articleId));
    articleDataPromises.set(articleId, promise);
    return promise;
}
function getPublishingDate(domain, articleId) {
    return getFeedId(domain).then(function (id) {
        return getPropertyFromPromisedObject(getArticleInformation(id, articleId), 'content', 'meta', 'published');
    });
}
function getUpdatedDate(domain, articleId) {
    return getFeedId(domain).then(function (id) {
        return getPropertyFromPromisedObject(getArticleInformation(id, articleId), 'content', 'meta', 'updated');
    });
}
function getTitle(domain, articleId) {
    return getFeedId(domain).then(function (id) {
        return getPropertyFromPromisedObject(getArticleInformation(id, articleId), 'content', 'meta', 'teaser', 'default', 'title');
    });
}
function getTitleHeader(domain, articleId) {
    return getFeedId(domain).then(function (id) {
        return getPropertyFromPromisedObject(getArticleInformation(id, articleId), 'content', 'meta', 'teaser', 'default', 'titleHeader');
    });
}
function getLead(domain, articleId) {
    return getFeedId(domain).then(function (id) {
        return getPropertyFromPromisedObject(getArticleInformation(id, articleId), 'content', 'meta', 'teaser', 'default', 'lead');
    });
}
function getDocType(domain, articleId) {
    return getFeedId(domain).then(function (id) {
        return getPropertyFromPromisedObject(getArticleInformation(id, articleId), 'content', 'paywall', 'docType');
    });
}
function isPremium(domain, articleId) {
    return getFeedId(domain).then(function (id) {
        return getPropertyFromPromisedObject(getArticleInformation(id, articleId), 'content', 'meta', 'settings', 'premium');
    });
}
function getFullCategoryPath(domain, articleId) {
    return getFeedId(domain).then(function (id) {
        return getPropertyFromPromisedObject(getArticleInformation(id, articleId), 'content', 'meta', 'mainCategoryFullUrlPath');
    });
}
function getCategory(domain, articleId) {
    return getFeedId(domain).then(function (id) {
        return getPropertyFromPromisedObject(getArticleInformation(id, articleId), 'content', 'meta', 'mainCategoryFullUrlPath').then(function (path) { return path === null || path === void 0 ? void 0 : path.split('/')[0]; });
    });
}
function getSubCategory(domain, articleId) {
    return getFeedId(domain).then(function (id) {
        return getPropertyFromPromisedObject(getArticleInformation(id, articleId), 'content', 'meta', 'mainCategoryFullUrlPath').then(function (path) {
            var splitPath = path === null || path === void 0 ? void 0 : path.split('/');
            return splitPath && splitPath[1] ? splitPath[1] : path;
        });
    });
}
function getAuthors(domain, articleId) {
    return getFeedId(domain).then(function (id) {
        return getPropertyFromPromisedObject(getArticleInformation(id, articleId), 'content', 'meta', 'authors').then(function (authorList) {
            var _a;
            return (_a = authorList === null || authorList === void 0 ? void 0 : authorList.map(function (authorObject) { return authorObject.name; })) !== null && _a !== void 0 ? _a : [];
        });
    });
}
function getCommentCounts(domain, articleId) {
    return getFeedId(domain).then(function (id) {
        return getPropertyFromPromisedObject(getArticleInformation(id, articleId), 'content', 'meta', 'clientData', 'community', 'comments').then(function (commentCount) { return (commentCount ? parseInt(commentCount, 10) : 0); });
    });
}
function getTeaserImgSrc(domain, articleId, teaserSize) {
    if (teaserSize === void 0) { teaserSize = '800px'; }
    return getFeedId(domain).then(function (id) {
        return getPropertyFromPromisedObject(getArticleInformation(id, articleId), 'content', 'meta', 'teaser', 'default', 'image', 'variants', teaserSize, 'src');
    });
}
function getUrl(domain, articleId) {
    return getFeedId(domain).then(function (id) {
        return getPropertyFromPromisedObject(getArticleInformation(id, articleId), 'content', 'meta', 'teaser', 'default', 'url').then(function (url) {
            if (!url) {
                return undefined;
            }
            if (/^https?:/.test(url)) {
                return url;
            }
            return "https://www." + domain + ".ch" + url;
        });
    });
}

var defaultSharingEndpoint = function (domainName, opts) {
    if (opts === void 0) { opts = {}; }
    var _a = opts.subdomain, subdomain = _a === void 0 ? 'www' : _a, _b = opts.version, version = _b === void 0 ? 'v1' : _b;
    return "https://" + subdomain + "." + domainName + ".ch/disco-api/" + version + "/sharing";
};
var countsEndpoint = function (domainName, articleId, opts) { return defaultSharingEndpoint(domainName, opts) + "/" + articleId; };
var shareSignalEndpoint = function (domainName, opts) {
    return "" + defaultSharingEndpoint(domainName, opts);
};

var defaultShareCounts = {
    facebook: 0,
    twitter: 0,
    whatsapp: 0,
    email: 0,
    native: 0,
    linkedin: 0,
    total: 0
};
var defaultOptions = {
    subdomain: 'www',
    version: 'v1'
};
function handleData$2(articleId) {
    return function (data) {
        return data.counts;
    };
}
function catchError$2(subclass) {
    return catchError('getSharingCounts', subclass, defaultShareCounts);
}
var shareCountPromiseCache = new Map();
function getSharingCounts(domainName, articleId) {
    if (shareCountPromiseCache.has(articleId)) {
        return shareCountPromiseCache.get(articleId);
    }
    var promise = fetch(countsEndpoint(domainName, articleId, defaultOptions))
        .then(handleRequest())
        .then(handleData$2())
        .catch(function (reason) {
        handleData$2()({
            counts: defaultShareCounts,
            articleId: articleId.toString()
        });
        throw reason;
    })
        .catch(catchError$2(HTTPError))
        .catch(catchError$2(Error));
    shareCountPromiseCache.set(articleId, promise);
    return promise;
}
function getTotalShareCount(domainName, articleId) {
    return getPropertyFromPromisedObject(getSharingCounts(domainName, articleId), 'total');
}

var defaultOptions$1 = {
    subdomain: 'www',
    version: 'v1'
};
function postShareSignal(domainName, articleId, shareType) {
    return fetch(shareSignalEndpoint(domainName, defaultOptions$1), {
        body: JSON.stringify({ articleId: articleId, sharingType: shareType }),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json; charset=utf-8'
        }
    })
        .then(handleRequest())
        .catch(function (reason) {
        console.warn("[postShareSignal]: share signal could not be delivered, due to\n        " + reason.name + ": " + reason.message + ".\n        While this might skew the statistics, worse things have happened.\n        ");
    });
}

var apiEndpoint$2 = 'https://interaktiv.tagesanzeiger.ch/static/config/gtm-id.json';
function handleData$3(domainName) {
    return function (ids) {
        var id = ids[domainName];
        if (!id) {
            throw new MissingInfoError("No data available for domain " + domainName);
        }
        return id;
    };
}
var catchError$3 = function (subclass) {
    return catchError('getGtmId', subclass);
};
var gtmIdPromise;
function getGtmId(domainName) {
    if (gtmIdPromise) {
        return gtmIdPromise;
    }
    var promise = fetch(apiEndpoint$2)
        .then(handleRequest())
        .then(handleData$3(domainName))
        .catch(catchError$3(Error));
    gtmIdPromise = promise;
    return promise;
}

export { getArticleInformation, getAuthors, getCategory, getCommentCounts, getDocType, getFacebookAppId, getFeedId, getFullCategoryPath, getGtmId, getLanguage, getLead, getNiceName, getPublishingDate, getSharingCounts, getSiteInformation, getSubCategory, getTeaserImgSrc, getTitle, getTitleHeader, getTotalShareCount, getTwitterHandle, getUpdatedDate, getUrl, isPremium, postShareSignal };
//# sourceMappingURL=index.m.js.map
